/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import { getItemById, addItem, updItem, getAllItemsIcons, addItemByCommunity } from '../../actions/itemAction';
import { getAllRooms, getRoomsByCommunityId } from '../../actions/roomAction';


import {renderTextField, renderThumbnailSelect,renderSwitchWithLabel} from '../../utils/engageComponents'

import PropTypes from 'prop-types';
import { Fab, Tab, Tabs } from '@material-ui/core';
import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { renderImage } from '../../utils/engageComponents'
import { sweetAlert } from "../../components/Alert/sweetAlert";

import {
    ADD_ITEM_SUCCESS,
    UPDATE_ITEM_SUCCESS
} from "../../constants/itemConstant";
import ItemIconsModal from "./ItemIconsModal";


const validate = (values, props) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Please enter a Name';
    } else if (values.name.length > props.characterLimit) {
        errors.name = `The item must have less than ${props.characterLimit} characters`;
    }

    if (!values.iconUrl) {
        errors.iconUrl = 'Please enter an Icon url ';
        //errors.iconResourceName = 'Please enter an Icon url or Icon resource name';
    }
    return errors;
};

  const  TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={1}>
            <Grid>{children}</Grid>
          </Box>
        )}
      </div>
    );
  };

  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };



class AddEditItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open : true,
            openThumbnailCombo:false,
            openModal:false,
            tab:0,
            nameEs:'',
            nameFr:'',
            _id: props.data._id,
            roomsByItem: props.data.rooms,
            iconUrl: props.data.iconUrl?props.data.iconUrl:'https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg',
            solidIcon:'',
            openIconsModal:false
        };

        if (props.data) {
            this.props.dispatch(change('ItemForm', '_id', props.data && props.data._id));
            this.props.dispatch(change('ItemForm', 'name', props.data && props.data.name));
            this.props.dispatch(change('ItemForm', 'iconUrl', props.data && props.data.iconUrl));
            this.props.dispatch(change('ItemForm', 'iconResourceName', props.data && props.data.iconResourceName));
        } else {
            this.props.dispatch(change('ItemForm', '_id', ''));
            this.props.dispatch(change('ItemForm', 'name', ''));
            this.props.dispatch(change('ItemForm', 'iconUrl', ''));
            this.props.dispatch(change('ItemForm', 'iconResourceName', ''));
        }

    }

    componentDidMount() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

        if (this.props.data !== '') {

            this.props.getItemById(this.props.data._id)
        }

        if(this.props.data?.translations && this.props.data.translations.length>0){

            const spanishObj = this.props.data.translations.find(x=>x.languageCode==='es');

            const frenchObj = this.props.data.translations.find(x=>x.languageCode==='fr');
            
            if(spanishObj){
                this.setState({nameEs:spanishObj.name});

                this.props.dispatch(change('ItemForm','nameEs', spanishObj.name)) ;

            }

            if(frenchObj){
                this.setState({nameFr:frenchObj.name});
                this.props.dispatch(change('ItemForm','nameFr', frenchObj.name)) ;

            }

        }


        if (communityId) {

            this.props.getRoomsByCommunityId(communityId, true);
            this.props.getAllItemsIcons();
        }

    }

    handleSelectIcon=(icon)=>{
        this.setState({iconUrl:icon.iconUrl, solidIcon:icon.solidIconUrl, openIconsModal:false})
    }

    handleCancel = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.setState({ roomsByItem: [] });
        }
    };

    onSubmitHandler = (formData) => {
        formData.rooms = this.state.roomsByItem
        formData.iconUrl = this.state.iconUrl

        if (formData.name.length > this.props.characterLimit) {
            const message = `The item must have less than ${this.props.characterLimit} characters`
            sweetAlert('error', message, 'alert_AddEditItem_CharacterLimit_Error');
            return;
        }

        if(!this.state.iconUrl || this.state.iconUrl ==='https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg'){
            const message = `Please select an Icon`
            sweetAlert('error', message, 'alert_AddEditItem_icon_error');
            return;
        }

        formData.translations=[];

        if(this.state.nameEs!==''){
            const spanishObj={
                languageCode:'es',
                name:this.state.nameEs,
            }

            formData.translations.push(spanishObj);
        }

        if(this.state.nameFr!==''){
            const frenchObj={
                languageCode:'fr',
                name:this.state.nameFr,
            }

            formData.translations.push(frenchObj);
        }

        let page = this.props.currentPage;

        if (!this.state._id) {

            this.props.addItemByCommunity(formData, localStorage.getItem('communityId')); //this.state._id);
            page = this.props.newItemPage

        } else {
            this.props.updItem(this.state._id, formData); //this.state._id); 

        }

        this.setState({ roomsByItem: [] })
        this.props.closeDialog(page);
    };




    handleToggle = (value) => {

        if (!this.state.roomsByItem) {
            const newChecked = [];
            newChecked.push(value);
            this.setState({ roomsByItem: newChecked })
        } else {
            const currentIndex = this.state.roomsByItem.indexOf(value);
            const newChecked = this.state.roomsByItem;

            if (currentIndex === -1) {
                newChecked.push(value);
            } else {
                newChecked.splice(currentIndex, 1);
            }
            this.setState({ roomsByItem: newChecked })
        }
    };


    handleChange = (event) => {
        //setState({ ...state, [event.target.name]: event.target.checked });
        if (event.target.checked)
            this.setState({ roomsByItem: (this.props && this.props.rooms && this.props.rooms.length > 0) ? this.props.rooms.map(room => room._id) : [] })
        else
            this.setState({ roomsByItem: [] })
    };


    //handle the state of the switch
    isSwitchChecked = () => {
        let isChecked = false;

        if (this.props.rooms && Array.isArray(this.props.rooms) && (typeof (this.state.roomsByItem) === 'object') && this.state.roomsByItem) {
            isChecked = !this.props.rooms.some((i) => this.state.roomsByItem.indexOf(i._id) === -1);
        }

        return isChecked;
    }

    handleSelectOptionChanged = (event, newitem) => {
        const iconUrl = newitem && newitem.iconUrl ? newitem.iconUrl : undefined

        this.setState({ iconUrl: iconUrl });
        this.props.dispatch(change('ItemForm', 'iconUrl', iconUrl));
        this.handleThumbnailCombo(null, false);

    }


    handleThumbnailCombo = (e, option) => {
        if (!option) {

            this.setState((prevState) => ({ openThumbnailCombo: !prevState.openThumbnailCombo }));
        } else {
            this.setState({ openThumbnailCombo: option });
        }
    }
    handleThumbnailOnBlur = () => {
        setTimeout(() => {
            this.setState({ openThumbnailCombo: false })
        }, 50);
    }

    handleChangeTab = (event, newValue) => {
        this.setState({tab:newValue});
    };

    a11yProps(lng) {
        return {
          id: `vertical-translation-tab-${lng}`,
          'aria-controls': `vertical-tabpanel-${lng}`,
        };
    }

    handleChangeTranslationIndex =(index)=>{
        this.setState({tab:index})
    }



    render() {
        const { handleSubmit } = this.props;
        const isUpdate = this.state._id ? this.state._id : '';
        const item = this.props.itemData ? this.props.itemData.filter((i) => i._id === isUpdate ? true : false) : {};
        let firstItem = typeof (item) === 'object' && item.length === 1 ? item[0] : item;
        firstItem.iconUrl = this.state.iconUrl;
        let selectedOption = firstItem && this.props.itemsIconsData ? this.props.itemsIconsData.filter((option) => option.iconUrl === firstItem.iconUrl ? true : false) : {};
        selectedOption = typeof (selectedOption) === 'object' && selectedOption.length === 1 ? selectedOption[0] : { name: '', iconUrl: '' };
        //selectedOption.iconUrl = this.state.iconUrl;


        /* THIS IS WHERE WE VALIDATE WHEN THE INFORMATION IS SAVED */
        if (this.props.isItemSuccess.success && (this.props.isItemSuccess.type === ADD_ITEM_SUCCESS || this.props.isItemSuccess.type === UPDATE_ITEM_SUCCESS)) {
            this.props.closeDialog(1);
        }


        return (
            <div className="FormDetailSubTitle-engage" style={{ width: '100%' }}>
                <form >
                    <Grid item sm={12} container alignItems="center">
                        <div className="imgalignrigth-engage appbtn-details-engage">
                            <div id="save_btn_items" className="appbtn-engage skybluebtn-engage" onClick={handleSubmit(this.onSubmitHandler.bind(this))}>
                                Save
                            </div>
                            <div id="cancel_btn_items" className="appbtn-engage redbtn-engage" onClick={this.props.closeDialog}>
                                Cancel
                            </div>
                        </div>
                    </Grid>
                    <Grid container className='formSection'>
                        <Grid item container xs={12} sm={12} md={6} alignContent='center' style={{padding:'20px'}}>
                            <Field
                                id={`items_add_item_name`}
                                name="name"
                                label="Name"
                                maxLength={20}
                                component={renderTextField}
                                inputLabelClass='defaultTextStyles'
                                inputClass='defaultTextStyles'
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} >

                            <Grid item xs={12} className='defaultTextStyles' >
                                Icon
                            </Grid>

                            <Grid item container xs={12} className="setUpGridColum">
                                <Grid item container xs={12} justify='center'>
                                    <img
                                        src={this.state.iconUrl}
                                        alt="icon"
                                        width='100px'
                                        height='100px'
                                        style={{opacity:(this.state.iconUrl==='https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg')?'56%':'100%'}}
                                    />
                                </Grid>

                                <Grid item container xs={12} justify='center' style={{marginTop:'2rem'}}>
                                    <Grid id='Select_Icon_Btn' item className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={()=>this.setState({openIconsModal:true})}>
                                        Select Icon
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* <Field
                                idToSet='items_icons_dropdown'
                                name="iconUrl"
                                label="Icon"
                                maxLength={20}
                                selected={selectedOption}
                                onChangeHandler={this.handleSelectOptionChanged}
                                optionsItemsIconsData={this.props.itemsIconsData ? this.props.itemsIconsData : []}
                                open={this.state.openThumbnailCombo}
                                component={renderThumbnailSelect}
                                onClick={this.handleThumbnailCombo}
                                onBlur={this.handleThumbnailOnBlur}
                                inputLabelClass='defaultTextStyles'
                                showStartAdornment={true}
                            /> */}
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} className='formSection' style={{ marginTop: '30px' }}>
                        <Grid item container >
                            <Grid item xs={12}>
                                <p className="category  defaultTextStyles">Rooms list</p>
                                <div style={{ textAlign: 'left' }}>
                                    <Grid item xs={6} md={4} lg={2} style={{ padding: '10px', paddingTop: '40px' }}>
                                        <Field
                                            name="selectAll"
                                            label="Select All"
                                            checked={this.isSwitchChecked()}
                                            onClick={this.handleChange}
                                            component={renderSwitchWithLabel}
                                            idToSet='selectAlltoogle'
                                            id='selectAlltoogle'

                                        />
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item container>
                            {
                                this.props.rooms && Array.isArray(this.props.rooms) && this.props.rooms.map((itemRoom, index) => {

                                    return (

                                        <Grid item xs={12} sm={6} md={3} style={{ padding: '4px' }} key={index}>
                                            <Card key={index} className=" cardElement " id={`items_room_card_${itemRoom._id}`} >
                                                <CardContent className="card-center-container medium " style={{ height: '100px' }}>
                                                    {
                                                        renderImage(itemRoom)
                                                    }
                                                </CardContent>
                                                <CardActions className="card-center-container CardActions">
                                                    <Grid item container xs={12} alignContent='center' style={{ height: '100%', overflow: 'hidden' }}>
                                                        <Grid item container xs={4}>
                                                            <Grid item container justify='center' alignContent='center' className='CheckboxBlue RepairsCell'>
                                                                <Checkbox
                                                                    id={`checkbox_${item._id}`}
                                                                    checked={this.state.roomsByItem ? this.state.roomsByItem.indexOf(itemRoom._id) !== -1 : false}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={() => this.handleToggle(itemRoom._id)}
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                                                    checkedIcon={
                                                                        <CheckBoxIcon fontSize="large" />
                                                                    }
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={8} alignContent='center' justify='center' style={{ overflow: 'hidden' }}>
                                                            <Grid item className='WrapText engage_Title' rows={3}>
                                                                {
                                                                    itemRoom.name
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                     
                    </Grid>

                    <Modal
                        open={this.props.openTranslation}
                        onClose={this.props.closeTranslation}
                    >
                        <Paper elevation={3}>
                            <Grid className='translationsModal'>
                                <Grid className="ModalTitle">Add translations</Grid>
                                <Grid item container xs={12} style={{marginTop:'1rem', marginBotton:'1rem'}}>
                                    <Tabs
                                        value={this.state.tab}
                                        onChange={this.handleChangeTab}
                                        aria-label="Translations tab"
                                        className='translationTabs'
                                        TabIndicatorProps={{style:{backgroundColor:'#009edd'}}}

                                    >
                                        <Tab label="ES" className={(this.state.tab === 0)?   "SelectedTranslationTabs": "translationTab"} {...this.a11yProps(0)} />
                                        <Tab label="FR" className={(this.state.tab === 1)?   "SelectedTranslationTabs": "translationTab"} {...this.a11yProps(1)} />

                                    </Tabs>

                                    <SwipeableViews
                                        axis={'x'}
                                        index={this.state.tab}
                                        onChangeIndex={this.handleChangeTranslationIndex}
                                    >

                                        <TabPanel value={0} index={0} className='translationTabContent'>
                                            <Grid item container xs={12} style={{marginTop:'1rem'}}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="nameEs"
                                                        label="Nombre"
                                                        maxLength={20}
                                                        onChange={(e, newItem ) => this.setState({nameEs: newItem})}
                                                        component={renderTextField}
                                                        id='nameEs'
                                                    />  
                                                </Grid>
                                            </Grid>
                                        </TabPanel>
                                                                
                                        <TabPanel value={1} index={1} className='translationTabContent'>
                                            <Grid item container xs={12} style={{marginTop:'1rem'}}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="nameFr"
                                                        label="nom"
                                                        maxLength={20}
                                                        onChange={(e, newItem ) => this.setState({nameFr: newItem})}
                                                        component={renderTextField}
                                                        id='nameFr'
                                                    />  
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                    </SwipeableViews>

                                    <Grid item container xs={12} alignItems='center' justify='center' style={{marginTop:'1rem'}}>
                                        <Grid 
                                            item container justify='center' alignItems='center'
                                            onClick={this.props.closeTranslation} 
                                            className='RepairsModalButtonCancel alingCenter'
                                        >
                                            Cancel
                                        </Grid>
                                        <Grid 
                                            item container justify='center' alignItems='center'
                                            onClick={this.props.closeTranslation} 
                                            className='RepairsModalButtonSchedule alingCenter'
                                        >
                                            Ok
                                        </Grid>
                                    </Grid>

                                </Grid>

                            </Grid>
                        </Paper>
                    
                    </Modal>

                    <Modal
                        open={this.state.openIconsModal}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ borderRadius: '16px' }}
                        onClose={() => this.setState({openIconsModal:false})}
                    >

                        <ItemIconsModal
                            onDone={this.handleSelectIcon}
                            onCancel={()=>this.setState({openIconsModal:false})}
                        />

                    </Modal>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {

    const itemData = state.itemReducer && state.itemReducer.itemData ? state.itemReducer.itemData : [];
    const roomData = state.roomReducer && state.roomReducer.roomData && Array.isArray(state.roomReducer.roomData) ? state.roomReducer.roomData : [];
    const itemsIconsData = state.itemReducer && state.itemReducer.itemsIconsData && state.itemReducer.itemsIconsData.icons ? state.itemReducer.itemsIconsData.icons : [];

    let initialValuesData = {};

    const itemSuccess = state.itemReducer;


    if (state.itemReducer && state.itemReducer.itemData && state.itemReducer.itemData.data) {
        initialValuesData._id = state.itemReducer.itemData.data._id
        initialValuesData.name = state.itemReducer.itemData.data.name
        initialValuesData.iconUrl = state.itemReducer.itemData.data.iconUrl
        initialValuesData.iconResourceName = state.itemReducer.itemData.data.iconResourceName
    }

    return {
        roomsByItem: [],
        initialValues: initialValuesData,
        itemData: itemData,
        rooms: roomData,
        itemsIconsData: itemsIconsData,
        isItemSuccess: itemSuccess
    };
}

export default connect(mapStateToProps, { getItemById, addItem, updItem, getAllRooms, getAllItemsIcons, addItemByCommunity, getRoomsByCommunityId })(reduxForm({
    form: 'ItemForm',
    validate,
    enableReinitialize: true,
})(AddEditItem));

